import script from "./TabInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TabInfo.vue?vue&type=script&setup=true&lang=js"

import "./TabInfo.vue?vue&type=style&index=0&id=53119db3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53119db3"]])

export default __exports__